import { ListUserExamsQuery } from 'src/@types/exam';

export const QUERY_KEY = {
  //---------------
  NOTIFICATION: {
    INDEX: 'notifications',
    NOTIFICATION_DETAIL: 'notification_detail',
    MY_NOTIFICATIONS: 'my_notifications',
    ADMIN: 'admin_notifications',
    ADMIN_DETAIL: 'admin_notifications_detail',
    ADMIN_DETAIL_NULL: 'admin_notifications_null',
  },
  MESSAGE: {
    CONVERSATIONS: 'conversations',
    CONVERSATION: 'conversation',
  },
  COURSE: {
    GET_ALL_CUSTOMIZE_COURSE: 'GET_ALL_CUSTOMIZE_COURSE',
    GET_ALL_COURSE: 'GET_ALL_COURSE',
    GET_CONTRIBUTION: 'GET_CONTRIBUTION',
    GET_ALL_ASK_COURSE: 'GET_ALL_ASK_COURSE',
    GET_DOCUMENT_BY_COURSE: 'GET_DOCUMENT_BY_COURSE',
    GET_STUDENTS_IN_COURSE: 'GET_STUDENTS_IN_COURSE',
    GET_COURSE_V2: 'GET_COURSE_V2',
    GET_COURSE_BY_FIELDS: 'GET_COURSE_BY_FIELDS',
    GET_COURSE_INQUIRIES_V2: 'GET_COURSE_INQUIRIES_V2',
    GET_ESSAY_BY_COURSE: 'GET_ESSAY_BY_COURSE',
    MARK_MESSAGE_AS_READ: 'MARK_MESSAGE_AS_READ',
    ASK: 'course-asks',
    ASK_INFINITE: 'course-asks-infinite',
  },

  //---------------
  GET_RANKING_BY_COURSE_ID: 'GET_RANKING_BY_COURSE_ID',
  GET_USER_ALL: 'GET_USER_ALL',
  GET_ID_NAME_USER: 'GET_ID_NAME_USER',
  GET_POSITION_ALL: 'GET_POSITION_ALL',
  GET_DEPARTMENT_ALL: 'GET_DEPARTMENT_ALL',
  GET_AREAS_ALL: 'GET_AREAS_ALL',
  GET_GROUP_ALL: 'GET_GROUP_ALL',
  GET_PARTNER_ALL: 'GET_PARTNER_ALL',
  // Categories
  GET_CATEGORIES_ALL: 'GET_CATEGORIES_ALL',
  // Course
  GET_NAME_AND_ID_COURSE: 'GET_NAME_AND_ID_COURSE',
  ORDER: {
    GET_ALL: 'GET_ALL_ORDERS',
  },
  NEWS: {
    GET_NEWS: 'GET_NEWS',
  },
  SCHEDULE: {
    GET_SCHEDULE: 'GET_SCHEDULE',
  },
  QUESTION: {
    GET_QUESTION: 'GET_QUESTION',
    GET_GROUP: 'GET_GROUP',
    GET_SURVEY: 'GET_SURVEY',
    GET_EXAM: 'GET_EXAM',
  },
  FOLDER: {
    GET: 'GET_ALL_FOLER',
  },
  ADMIN: {
    USER_LEARNING_PROGRESS: 'ADMIN_USER_LEARNING_PROGRESS',
    SELECT_NOTIFICATIONS: 'SELECT_NOTIFICATIONS',
  },
  CERTIFICATE: {
    GET: 'CERTIFICATE_GET',
  },
  SURVEY: {
    GET_ALL: 'SURVEY_GET_ALL',
  },
  CLIENT: {
    GET_ALL_COURSE: 'CLIENT_GET_ALL_COURSE',
    GET_ALL_COURSE_BY_SLUG: 'CLIENT_GET_ALL_COURSE_BY_SLUG',
    GET_SURVEY_BY_SLUG: 'GET_SURVEY_BY_SLUG',
    GET_SURVEY_RESULT_BY_SLUG: 'GET_SURVEY_RESULT_BY_SLUG',
    GET_ROOM_CHAT_BY_CODE: 'GET_ROOM_CHAT_BY_CODE',
    GET_ALL_ASK_COURSE_BY_USER_ID: 'GET_ALL_ASK_COURSE_BY_USER_ID',
    GET_ALL_DOCUMENT: 'GET_ALL_DOCUMENT',
    GET_ALL_MENTORING: 'GET_ALL_MENTORING',
    GET_ALL_CUSTOMIZE_USER: 'GET_ALL_CUSTOMIZE_USER',
    GET_ALL_NOTIFICATION: 'GET_ALL_NOTIFICATION',
    GET_LOGIN_HISTORY: 'GET_LOGIN_HISTORY',
    GET_SURVEY_OPINION_POLL: 'GET_SURVEY_OPINION_POLL',
  },
  RANKING: {
    GET_RANKING: 'GET_RANKING',
  },
  DASHBOARD: {
    ADMINISTRATOR: {
      GET_USER: 'DASHBOARD_ADMIN_GET_USER',
      GET_BUNNY: 'DASHBOARD_ADMIN_GET_BUNNY',
      GET_COURSE: 'DASHBOARD_ADMIN_GET_COURSE',
    },
  },
};

export const SURVEY_KEYS = {
  all: ['surveys'] as const,
  list: (q?: string, page?: number, pageSize?: number) =>
    [...SURVEY_KEYS.all, 'list', { q, page, pageSize }] as const,
  detail: (id: string) => [...SURVEY_KEYS.all, 'detail', id] as const,
  bySlug: (slug: string) => [...SURVEY_KEYS.all, 'slug', slug] as const,
  byUserSurvey: (userId: string, surveyId: string) =>
    [...SURVEY_KEYS.all, 'user', userId, 'survey', surveyId] as const,
};

export const EXAM_KEYS = {
  all: ['exams'] as const,
  studentBySlug: (slug: string) => [...EXAM_KEYS.all, 'student', slug] as const,
  list: () => [...EXAM_KEYS.all, 'list'] as const,
  byUser: () => [...EXAM_KEYS.all, 'byUser'] as const,
  byUserParams: (params: ListUserExamsQuery) => [...EXAM_KEYS.byUser(), params] as const,
};

export const AUDIT_KEYS = {
  all: ['audit'] as const,
  list: (params: {
    examId: string;
    userId?: string;
    from?: string;
    to?: string;
    q?: string;
    page?: number;
    pageSize?: number;
  }) => [...AUDIT_KEYS.all, 'list', params] as const,
};
